module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"serpMedian":"SERP Median: ","calculatedAt":"Calculated at: {date}","noDataForKeyword":"No data for this keyword"},"fr":{"serpMedian":"Médiane de la SERP : ","calculatedAt":"Calculé le: {date}","noDataForKeyword":"Pas de données pour ce mot clé"},"de":{"serpMedian":"SERP-Median:","calculatedAt":"Berechnet am: {date}","noDataForKeyword":"Keine Daten für dieses Keyword"}}')
  delete Component.options._Ctor
}
